<template>
<div>
    <div v-if="loading == false">
        <div id="custom-search-input">
            <div class="input-group col-md-2">
                <input type="text" class="search-query form-control" v-model="search" :placeholder="Buscar" />
                <span class="input-group-btn">
          <button class="btn btn-danger" type="button">
              <span class=" glyphicon glyphicon-search"></span>
                </button>
                </span>
            </div>
        </div>

        <div class="checkbox">
            <label><input type="checkbox" v-model="check" @change="console" value="">{{ $t('ONLY_APPROVED_TRANSACTIONS') }}</label>
        </div>
        <br>
        <div class="box box-primary direct-chat direct-chat-primary">
            <div class="box-body">
                <vue-good-table :columns="columns" :rows="transactions" :search-options="{
                enabled: false,
                trigger: 'enter',
               
                }" :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  dropdownAllowAll: false,
                  nextLabel: $t('TRANSACTION_TABLE.NEXT') ,
                  prevLabel:$t('TRANSACTION_TABLE.BACK') ,
                  ofLabel: $t('TRANSACTION_TABLE.OF') ,
                  rowsPerPageLabel:$t('TRANSACTION_TABLE.ROWS_PER_PAGES'),

                }" styleClass="vgt-table condensed">
                    <template slot="table-column" slot-scope="props">
                        <th v-if="props.column.field == 'date'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'store_ID'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'store_Name'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'user'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'provider'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'host'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'amount'"> {{ props.column.label | translate }} </th>
                        <th v-if="props.column.field == 'resp_Code'"> {{ props.column.label | translate }} </th>
                        <th v-if="props.column.field == 'resp_Desc'"> {{ props.column.label | translate }} </th>
                        <th v-if="props.column.field == 'pin_Phone'"> {{ props.column.label | translate }} </th>
                        <th v-if="props.column.field == 'balance_After'"> {{ props.column.label | translate }} </th>
                        <th v-if="props.column.field == 'auth_Number'"> {{ props.column.label | translate }} </th>
                        <th v-if="props.column.field == 'TransactDetails'"> {{ props.column.label | translate }} </th>
                        <th v-if="props.column.field == 'estado'"> {{ props.column.label | translate }} </th>
                    </template>

                    <template slot="table-row" scope="props">
                        <td v-if="props.column.field == 'date'"> {{ props.row.date | formatDate }}</td>
                        <td v-if="props.column.field == 'store_ID'"> {{ props.row.store_ID }}</td>
                        <td v-if="props.column.field == 'store_Name'"> {{ props.row.store_Name }}</td>
                        <td v-if="props.column.field == 'user'"> {{ props.row.user }}</td>
                        <td v-if="props.column.field == 'provider'"> {{ props.row.provider }}</td>
                        <td v-if="props.column.field == 'host'"> {{ props.row.host | translate}}</td>
                        <td v-if="props.column.field == 'amount'"> {{ props.row.amount | Decimal }} </td>
                        <td v-if="props.column.field == 'resp_Code'"> {{ props.row.resp_Code}}</td>
                        <td v-if="props.column.field == 'resp_Desc'"> {{ props.row.resp_Desc }}</td>
                        <td v-if="props.column.field == 'pin_Phone'"> {{ props.row.pin_Phone }}<br><b>Serial:</b>{{props.row.serial}}
                        </td>
                        <td v-if="props.column.field == 'balance_After'"> {{ props.row.balance_After}}</td>
                        <td v-if="props.column.field == 'auth_Number'"> {{ props.row.auth_Number }}</td>

                        <td v-if="props.column.field == 'id'">
                            <router-link class="btn btn-default" :to="{ name:'TransactionLogDetails', params:{ id:props.row.id } }"> {{ $t('DETAILS') }} </router-link>
                        </td>

                        <td v-if="props.column.field == 'Estado'"><button class="btn btn-default"><span><i v-bind:class="props.row.estatus | checkStatus"  style="font-size:30px;"></i></span></button> </td>

                    </template>

                </vue-good-table>
            </div>
        </div>
    </div>
    <div v-else>
        <center>
            <div class="fa fa-spinner fa-pulse text-blue" style="font-size:100px;"></div>
        </center>
    </div>

</div>
</template>

<script>
import swal from "sweetalert";
import _ from "lodash";
export default {
    name: "transactions",
    watch: {
        search: _.debounce(function (newVal) {
            this.searchingTransact();
        }, 1000)
    },
    data() {
        return {
            check: false,
            Buscar: this.$t("SEARCH"),
            columns: [{
                    label: "TRANSACTION_TABLE.COLUMS.DATE",
                    field: "date"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.ENTITY_ID",
                    field: "store_ID",
                    type: "number"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.ENTITY_NAME",
                    field: "store_Name"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.USERS",
                    field: "user"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.PROVIDER",
                    field: "provider"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.HOST",
                    field: "host"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.APPROVED_AMOUNT",
                    field: "amount",
                    tdClass: "text-center"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.RESPONSE_CODE_STATUS",
                    field: "resp_Code"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.RESP_DESC",
                    field: "resp_Desc",
                    tdClass: "text-center"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.PIN_PTHONE_SERIAL",
                    field: "pin_Phone",
                    tdClass: "text-center"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.TRANSACTION_TYPE",
                    field: "transaction_Type"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.BALANCE_AFTER",
                    field: "balance_After"
                },

                {
                    label: "TRANSACTION_TABLE.COLUMS.AUTH_CODE",
                    field: "auth_Number",
                    type: "string"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.TRANSATION_DETAILS",
                    field: "id",
                    html: true
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.STATUS",
                    field: "Estado",
                    tdClass: "text-center",
                    html: true
                }
            ],
            loading: false,
            transactions: [],
            statusColor: "",
            oldTransact: [],
            search: ""
        };
    },
    created() {
        let self = this;
        self.getAll();
        if (this.check == true) {}
    },
    methods: {
        async console() {
            let self = this;
            self.loading = true;

            if (self.check == true) {
                self.transactions = await this.charginData(self.transactions);
            } else {
                self.transactions = await this.charginData(self.oldTransact);
            }
            self.loading = false;
        },
        charginData(allTransaction) {
            let self = this;
            return new Promise((resolve, reject) => {
                let show = [];

                for (let transact of allTransaction) {
                    if (self.check === true) {
                        if (self.$route.name == "transactionlog_index") {
                            show.push(transact);
                        } else if (
                            self.$route.name == "Without-request-log" &&
                            transact.estatus == "Sin-peticion"
                        ) {
                            show.push(transact);
                        } else if (
                            self.$route.name == "Pending-log" &&
                            transact.estatus == "Pendiente"
                        ) {
                            show.push(transact);
                        } else if (
                            self.$route.name == "Approved-log" &&
                            transact.estatus == "Aprobado"
                        ) {
                            show.push(transact);
                        } else if (
                            self.$route.name == "rejected-log" &&
                            transact.estatus == "Rechazado"
                        ) {
                            show.push(transact);
                        }
                    } else {
                        if (self.$route.name == "transactionlog_index") {
                            show.push(transact);
                        } else if (
                            self.$route.name == "Without-request-log" &&
                            transact.estatus == "Sin-peticion"
                        ) {
                            show.push(transact);
                        } else if (
                            self.$route.name == "Pending-log" &&
                            transact.estatus == "Pendiente"
                        ) {
                            show.push(transact);
                        } else if (
                            self.$route.name == "Approved-log" &&
                            transact.estatus == "Aprobado"
                        ) {
                            show.push(transact);
                        } else if (
                            self.$route.name == "rejected-log" &&
                            transact.estatus == "Rechazado"
                        ) {
                            show.push(transact);
                        }
                    }
                }

                resolve(show);
            });
        },
        async getAll() {
            let self = this;
            self.loading = true;
            try {
                let allTransaction = await self.$store.state.services.transactionLogService.getAll(
                    JSON.parse(self.$store.getters.user).token
                );

                self.transactions = await this.charginData(allTransaction.data);
                console.log(self.transactions);
                self.oldTransact = await allTransaction.data;

                self.loading = false;
            } catch (reason) {
                console.log({
                    reason
                });
                swal({
                    title: reason.response.data.error,
                    icon: "warning",
                    dangerMode: false
                }).then(clicket => {
                    self.loading = false;
                });
            }
        },
        searchingTransact() {
            this.transactions = this.oldTransact.filter(transaction => {
                return (
                    transaction.Entity_Id.match(this.search) ||
                    transaction.Authorization_Id.match(this.search)
                );
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/transactionLog.vue